/* FORSTAKK storefront behaviour. Ported from the approved prototype and
 * wired to Shopify: Ajax Cart API, Section Rendering API, predictive search.
 * Event delegation keeps everything working after theme-editor reloads.
 */
(() => {
const FSK = window.FSK || {};
const S = FSK.strings || {};
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const store = {
  get(k){ try { return sessionStorage.getItem(k); } catch(e){ return null; } },
  set(k, v){ try { sessionStorage.setItem(k, v); } catch(e){} },
  del(k){ try { sessionStorage.removeItem(k); } catch(e){} }
};

/* ====================== UI HELPERS ====================== */
function openDrawer(id){ const d = document.getElementById(id); if (!d) return; d.classList.add("open"); document.body.style.overflow = "hidden"; const c = $("[data-drawer-close]:not(.scrim)", d); if (c) c.focus({ preventScroll:true }); }
function closeDrawer(id){ const d = document.getElementById(id); if (!d) return; d.classList.remove("open"); document.body.style.overflow = ""; }
let tt;
function toastMsg(m){ const t = $("#toast"); if (!t) return; t.textContent = m; t.classList.add("show"); clearTimeout(tt); tt = setTimeout(() => t.classList.remove("show"), 1800); }

// "Order today, ships by ..." (skips weekends)
function shipDate(){
  const d = new Date(); let n = FSK.productionDays || 3;
  while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
  return d.toLocaleDateString(FSK.locale || "en-US", { weekday:"short", month:"short", day:"numeric" });
}
const fillShipDates = (root = document) => { const t = shipDate(); $$("[data-ship-date]", root).forEach(el => el.textContent = t); };

// Sticky offset for the 3D hero and product gallery
function measureHeader(){ const h = $(".fsk-header-section"); if (h) document.documentElement.style.setProperty("--hdr-h", h.offsetHeight + "px"); }

/* ====================== CART (Ajax Cart API) ====================== */
const Cart = window.FSKCart = {
  busy(on){ const p = $("[data-cart-panel]"); if (p) p.setAttribute("aria-busy", on ? "true" : "false"); },
  render(sections){
    const html = sections && sections["cart-drawer"];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const fresh = $("[data-cart-inner]", doc), cur = $("[data-cart-inner]");
    if (fresh && cur) { cur.replaceWith(fresh); fillShipDates(fresh); }
    const count = fresh ? fresh.dataset.count : null;
    if (count !== null) $$("[data-cart-count]").forEach(b => b.textContent = count);
  },
  open(){ if (FSK.cartType === "page") { location.href = FSK.routes.cart; return; } openDrawer("cartDrawer"); },
  async post(url, body, isForm){
    const opts = { method:"POST", headers:{ "Accept":"application/json" } };
    if (isForm) opts.body = body;
    else { opts.headers["Content-Type"] = "application/json"; opts.body = JSON.stringify(body); }
    const res = await fetch(url, opts);
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) throw new Error(data.description || data.message || S.error);
    return data;
  },
  async add(items, btn, formData){
    if (btn) { btn.disabled = true; btn.setAttribute("aria-busy", "true"); }
    try {
      let data;
      if (formData) {
        formData.append("sections", "cart-drawer");
        formData.append("sections_url", location.pathname);
        data = await Cart.post(FSK.routes.cartAdd + ".js", formData, true);
      } else {
        data = await Cart.post(FSK.routes.cartAdd + ".js", { items, sections:"cart-drawer", sections_url:location.pathname });
      }
      if ($("[data-cart-page]") || FSK.cartType === "page") { location.href = FSK.routes.cart; return true; }
      Cart.render(data.sections);
      Cart.open();
      return true;
    } catch (e) {
      toastMsg(e.message || S.error);
      return false;
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute("aria-busy"); }
    }
  },
  async change(line, quantity){
    Cart.busy(true);
    try {
      const data = await Cart.post(FSK.routes.cartChange + ".js", { line, quantity, sections:"cart-drawer", sections_url:location.pathname });
      if ($("[data-cart-page]")) { location.reload(); return; }
      Cart.render(data.sections);
    } catch (e) { toastMsg(e.message || S.error); }
    finally { Cart.busy(false); }
  }
};

/* ====================== CLICK DELEGATION ====================== */
document.addEventListener("click", e => {
  const t = e.target;
  let el;

  if ((el = t.closest("[data-drawer-open]"))) { openDrawer(el.dataset.drawerOpen); return; }
  if ((el = t.closest("[data-drawer-close]"))) { closeDrawer(el.dataset.drawerClose); return; }

  if ((el = t.closest("[data-cart-open]")) && FSK.cartType !== "page" && $("#cartDrawer")) { e.preventDefault(); openDrawer("cartDrawer"); return; }

  // Mega menu
  if ((el = t.closest("[data-mega-toggle]"))) {
    const panel = document.getElementById(el.dataset.megaToggle), wasOpen = panel && panel.classList.contains("open");
    closeMega();
    if (panel && !wasOpen) { panel.classList.add("open"); el.setAttribute("aria-expanded", "true"); }
    return;
  }
  if (!t.closest(".site-header")) closeMega();

  // Search bar
  if ((el = t.closest("[data-search-toggle]"))) {
    const bar = $("[data-search]"); if (!bar) return;
    bar.classList.toggle("open");
    el.setAttribute("aria-expanded", bar.classList.contains("open"));
    if (bar.classList.contains("open")) $("[data-predictive-input]", bar).focus();
    return;
  }

  // Room filter (tags on products)
  if ((el = t.closest("[data-room-filter] .room"))) {
    const sec = el.closest("[data-room-filter]"), room = el.dataset.room;
    $$(".room", sec).forEach(x => { x.classList.toggle("active", x === el); x.setAttribute("aria-pressed", x === el); });
    let shown = 0;
    $$("[data-card]", sec).forEach(c => { const ok = !room || c.dataset.rooms.includes("|" + room + "|"); c.hidden = !ok; if (ok) shown++; });
    const empty = $("[data-room-empty]", sec); if (empty) empty.hidden = shown > 0;
    return;
  }

  // Size buttons on product cards
  if ((el = t.closest(".card [data-size]"))) {
    const card = el.closest(".card");
    $$("[data-size]", card).forEach(b => b.setAttribute("aria-pressed", b === el));
    const price = $("[data-price]", card);
    if (price) { price.textContent = el.dataset.price; if (el.dataset.compare) { const s = document.createElement("s"); s.textContent = el.dataset.compare; price.appendChild(s); } }
    const save = $("[data-save]", card);
    if (save) { save.textContent = el.dataset.save; save.hidden = !el.dataset.save; }
    const add = $("[data-add]", card);
    if (add) { add.dataset.add = el.dataset.id; const ok = el.dataset.available === "true"; add.disabled = !ok; add.textContent = ok ? S.addToCart : S.soldOut; }
    return;
  }

  // Colour dots on product cards: photo, price and quick add follow the colour
  if ((el = t.closest(".card [data-swatch]"))) {
    e.preventDefault();
    const card = el.closest(".card");
    $$("[data-swatch]", card).forEach(b => b.setAttribute("aria-pressed", b === el));
    const img = $(".art img", card);
    if (img && el.dataset.img) { img.removeAttribute("srcset"); img.src = el.dataset.img; }
    const price = $("[data-price]", card);
    if (price) { price.textContent = el.dataset.price; if (el.dataset.compare) { const s = document.createElement("s"); s.textContent = el.dataset.compare; price.appendChild(s); } }
    const add = $("[data-add]", card);
    if (add && el.dataset.id) { add.dataset.add = el.dataset.id; add.disabled = el.dataset.available !== "true"; }
    return;
  }

  // Add one item (cards, cart cross-sell)
  if ((el = t.closest("[data-add]"))) { e.preventDefault(); Cart.add([{ id:+el.dataset.add, quantity:1 }], el); return; }

  // Drawer quantity buttons
  if ((el = t.closest("[data-cart-inner] [data-line]"))) { Cart.change(+el.dataset.line, +el.dataset.qty); return; }

  // Quantity steppers (product page, cart page)
  if ((el = t.closest(".qty-field [data-step]"))) {
    const input = $("input", el.closest(".qty-field"));
    const min = input.min !== "" ? +input.min : 1;
    input.value = Math.max(min, (+input.value || 0) + +el.dataset.step);
    input.dispatchEvent(new Event("change", { bubbles:true }));
    return;
  }

  // Product gallery thumbnails
  if ((el = t.closest("[data-thumb]"))) { showMedia(el.closest("[data-product-section]"), el); return; }

  // Promo row arrows: one card per click
  if ((el = t.closest("[data-promo-step]"))) {
    const row = $("[data-promo-row]", el.closest("[data-promo]")), card = row && row.firstElementChild;
    if (card) row.scrollBy({ left:(card.offsetWidth + 16) * +el.dataset.promoStep, behavior:"smooth" });
    return;
  }

  // Offer popup close
  if (t.closest("[data-offer-close]")) { closeOffer(); return; }
});

document.addEventListener("keydown", e => {
  if (e.key !== "Escape") return;
  closeMega(); closeOffer(); closeDrawer("menuDrawer"); closeDrawer("cartDrawer");
});

function closeMega(){
  $$("[data-mega].open").forEach(m => m.classList.remove("open"));
  $$("[data-mega-toggle]").forEach(b => b.setAttribute("aria-expanded", "false"));
}

/* ====================== PREDICTIVE SEARCH ====================== */
let searchTimer, searchCtrl;
document.addEventListener("input", e => {
  const input = e.target.closest("[data-predictive-input]");
  if (!input) return;
  clearTimeout(searchTimer);
  const out = $("[data-predictive-results]", input.closest("[data-search]"));
  const q = input.value.trim();
  if (!q) { out.innerHTML = ""; return; }
  searchTimer = setTimeout(async () => {
    if (searchCtrl) searchCtrl.abort();
    searchCtrl = new AbortController();
    try {
      const url = `${FSK.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][prefix]=last&section_id=predictive-search`;
      const html = await (await fetch(url, { signal:searchCtrl.signal })).text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const sec = $("#shopify-section-predictive-search", doc);
      out.innerHTML = sec ? sec.innerHTML : "";
    } catch (err) { if (err.name !== "AbortError") out.innerHTML = ""; }
  }, 220);
});

/* ====================== PRODUCT PAGE ====================== */
function showMedia(section, thumb){
  if (!section || !thumb) return;
  const img = $(".gallery .main img", section);
  if (img) { img.removeAttribute("srcset"); img.src = thumb.dataset.src; img.alt = thumb.dataset.alt || ""; }
  $$("[data-thumb]", section).forEach(b => b.setAttribute("aria-current", b === thumb));
}

document.addEventListener("click", e => {
  const btn = e.target.closest("[data-variant-picker] [data-opt]");
  if (!btn) return;
  const colorNav = btn.closest(".swatches[data-color-nav]");
  if (colorNav) {
    try { const map = JSON.parse(colorNav.dataset.colorNav); const url = map[btn.dataset.value]; if (url && location.pathname !== url) location.href = url; } catch(err) {}
    return;
  }
  const section = btn.closest("[data-product-section]");
  $$(`[data-opt="${btn.dataset.opt}"]`, section).forEach(b => b.setAttribute("aria-pressed", b === btn));
  const label = $(`[data-opt-label="${btn.dataset.opt}"]`, section); if (label) label.textContent = btn.dataset.value;
  const chosen = [];
  $$("[data-variant-picker] .opt", section).forEach((g, i) => { const on = $('[aria-pressed="true"]', g); chosen[i] = on ? on.dataset.value : null; });
  const variants = JSON.parse($("[data-variants]", section).textContent);
  const v = variants.find(x => x.options.every((o, i) => o === chosen[i]));
  // the mobile bar only adds to cart once the shopper has picked a size themselves
  const bar = $("[data-buybar-btn]", section);
  if (bar && (btn.closest(".sizes") || !$(".sizes", btn.closest("[data-variant-picker]")))) { bar.dataset.picked = "true"; bar.textContent = bar.dataset.labelAdd; }
  updateVariant(section, v);
});

function updateVariant(section, v){
  const btn = $("[data-add-btn]", section), idInput = $("[data-variant-id]", section);
  if (!v) { if (btn) { btn.disabled = true; btn.textContent = S.unavailable; } return; }
  if (idInput) idInput.value = v.id;
  if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? S.addToCart : S.soldOut; }
  const price = $("[data-price]", section);
  if (price) { price.textContent = v.price; if (v.compare) { const s = document.createElement("s"); s.textContent = v.compare; price.appendChild(s); } }
  const note = $("[data-photo-note]", section);
  if (note) {
    note.hidden = !!v.media;
    const colorMatch = v.title.match(/–\s*(Black|White|Gold|Red|Silver)$/i);
    if (colorMatch) {
      const color = colorMatch[1];
      note.textContent = `Photos show the ${color} finish. Your piece is made in the colour you choose.`;
    }
  }
  if (v.media) showMedia(section, $(`[data-thumb][data-media-id="${v.media}"]`, section));
  const bv = $("[data-buybar-variant]", section), bp = $("[data-buybar-price]", section);
  if (bv) bv.textContent = v.title;
  if (bp) bp.textContent = v.price;
  const sg = $("[data-size-guide]", section);
  if (sg && sg._select) v.options.forEach(o => sg._select(o));
  const url = new URL(location.href); url.searchParams.set("variant", v.id); history.replaceState(null, "", url);
}

/* ---------- Size guide: every size on one wall, drawn to scale ---------- */
function parseSize(raw){
  const s = String(raw).replace(/[”″“]/g, '"').replace(/\(.*?\)/g, " ");
  const marked = [...s.matchAll(/(\d+(?:\.\d+)?)\s*"?\s*([HW])\b/gi)];
  if (marked.length >= 2) { const o = {}; marked.forEach(m => o[m[2].toUpperCase()] = +m[1]); return { w:o.W, h:o.H }; }
  const n = [...s.matchAll(/\d+(?:\.\d+)?/g)].map(m => +m[0]);
  if (n.length >= 2) return { w:n[0], h:n[1] };
  if (n.length === 1) return { w:n[0], h:n[0] };
  return null;
}
function initSizeGuide(el){
  if (el._ready) return; el._ready = true;
  const names = JSON.parse($("script", el).textContent), circle = el.dataset.shape === "circle";
  const sizes = names.map(n => Object.assign({ name:n }, parseSize(n))).filter(x => x.w);
  if (!sizes.length) { el.hidden = true; return; }
  const tabs = $(".sg-tabs", el), stage = $(".sg-stage", el);
  const W = 150, H = 104, floor = 100, sofaW = 84, sofaH = 34, gap = 8, cx = W / 2;
  let current = sizes.findIndex(z => z.name === el.dataset.selected);
  if (current < 0) current = Math.floor((sizes.length - 1) / 2);
  const piece = (z, cls) => {
    const bottom = floor - sofaH - gap;
    return circle ? `<ellipse class="${cls}" cx="${cx}" cy="${bottom - z.h / 2}" rx="${z.w / 2}" ry="${z.h / 2}"/>`
                  : `<rect class="${cls}" x="${cx - z.w / 2}" y="${bottom - z.h}" width="${z.w}" height="${z.h}" rx=".6"/>`;
  };
  function draw(){
    const z = sizes[current], bottom = floor - sofaH - gap;
    const outlines = sizes.map((o, i) => i === current ? "" : piece(o, "sg-other")).join("");
    const dim = circle && z.w === z.h ? "Ø " + z.w + "″" : z.w + "″ × " + z.h + "″";
    stage.innerHTML = `<svg viewBox="0 0 ${W} ${H}" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect class="sg-wall" x="0" y="0" width="${W}" height="${floor}"/><rect class="sg-floor" x="0" y="${floor}" width="${W}" height="${H - floor}"/>
      <g class="sg-sofa"><rect x="${cx - sofaW / 2}" y="${floor - sofaH + 6}" width="${sofaW}" height="${sofaH - 10}" rx="3"/>
      <rect x="${cx - sofaW / 2 - 3}" y="${floor - 24}" width="8" height="18" rx="3"/><rect x="${cx + sofaW / 2 - 5}" y="${floor - 24}" width="8" height="18" rx="3"/>
      <rect x="${cx - sofaW / 2 + 4}" y="${floor - 6}" width="3" height="6"/><rect x="${cx + sofaW / 2 - 7}" y="${floor - 6}" width="3" height="6"/></g>
      ${outlines}${piece(z, "sg-current")}
      <text class="sg-dim" x="${cx}" y="${Math.max(6, bottom - z.h - 3)}" text-anchor="middle">${dim}</text>
      <text class="sg-sofa-label" x="${cx}" y="${floor - 12}" text-anchor="middle">84″ sofa</text>
    </svg>`;
    $$("button", tabs).forEach((b, i) => b.setAttribute("aria-pressed", i === current));
  }
  tabs.innerHTML = "";
  sizes.forEach((z, i) => { const b = document.createElement("button"); b.type = "button"; b.textContent = z.name; b.onclick = () => { current = i; draw(); }; tabs.appendChild(b); });
  el._select = name => { const i = sizes.findIndex(z => z.name === name); if (i >= 0) { current = i; draw(); } };
  draw();
}

/* ---------- Size options: every size to scale, stacked like the product chart ---------- */
function drawSizeOptions(el){
  const compact = el.clientWidth < 640;
  if (el._done === (compact ? "c" : "w")) return;
  el._done = compact ? "c" : "w";
  $$("svg, .so-legend", el).forEach(n => n.remove());
  if (!el._resize) { el._resize = true; addEventListener("resize", () => drawSizeOptions(el)); }
  const names = JSON.parse($("script", el).textContent);
  const sizes = names.map(n => Object.assign({ name:n }, parseSize(n))).filter(z => z.w && z.h).sort((a, b) => a.w * a.h - b.w * b.h);
  if (!sizes.length) { el.hidden = true; return; }
  const sky = el.dataset.skyline, text = el.dataset.text || "";
  const step = 2.6, labelW = compact ? 0 : 17, gap = compact ? 1 : 7, n = sizes.length, big = sizes[n - 1];
  const X0 = labelW + gap, top = 2, H = big.h + (n - 1) * step + 4, W = X0 + big.w + (n - 1) * step + 2;
  const BOT = H - 2;
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;" }[c]));
  const cm = v => (v * 2.54).toFixed(1).replace(/\.0$/, "");
  let boards = "", labels = "";
  // back to front: largest first
  for (let r = n - 1; r >= 0; r--) {
    const z = sizes[r], x = X0 + r * step, y = BOT - r * step - z.h;
    const inset = z.w * .028, ww = z.w - inset * 2, wh = ww * 0.222, sh = ww * 0.244, hr = Math.max(.28, z.w * .009);
    boards += `<g class="so-board">
      <rect x="${x}" y="${y}" width="${z.w}" height="${z.h}" rx=".5" class="so-steel"/>
      <rect x="${x + inset}" y="${y + inset}" width="${ww}" height="${wh}" class="so-window"/>
      <image href="${esc(sky)}" x="${x + inset}" y="${y + inset}" width="${ww}" height="${sh}" preserveAspectRatio="none"/>
      ${[[x + inset * .55, y + inset * .55], [x + z.w - inset * .55, y + inset * .55], [x + inset * .55, y + z.h - inset * .55], [x + z.w - inset * .55, y + z.h - inset * .55]]
        .map(([cx, cy]) => `<circle cx="${cx}" cy="${cy}" r="${hr}" class="so-hole"/>`).join("")}
      ${r === 0 && text ? `<text x="${x + z.w / 2}" y="${y + z.h - z.h * .1}" text-anchor="middle" class="so-script" font-size="${(z.w * .07).toFixed(2)}">${esc(text)}</text>` : ""}
    </g>`;
  }
  // labels: top to bottom in the same order as the boards' top edges
  const tops = sizes.map((z, r) => ({ z, r, y:BOT - r * step - z.h })).sort((a, b) => a.y - b.y);
  if (compact) {
    // phones: board numbers on the drawing, a readable list underneath
    tops.forEach(t => { labels += `<g class="so-tag"><circle cx="${X0 + t.r * step + 1.6}" cy="${t.y + 1.6}" r="1.25"/><text x="${X0 + t.r * step + 1.6}" y="${t.y + 2.05}" text-anchor="middle">${n - t.r}</text></g>`; });
    el.insertAdjacentHTML("beforeend", `<svg viewBox="0 0 ${W} ${H + 3}" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${boards}${labels}</svg>` +
      `<ol class="so-legend">${tops.map(t => `<li><span class="so-num">${n - t.r}</span><strong>${t.z.w} × ${t.z.h} in</strong><span>${cm(t.z.w)} × ${cm(t.z.h)} cm</span></li>`).join("")}</ol>`);
    return;
  }
  const rowH = (H - 4) / n;
  tops.forEach((t, i) => {
    const ly = top + rowH * i + rowH / 2 - 1.2, edgeX = X0 + t.r * step, edgeY = t.y + Math.min(2.2, step * .8);
    labels += `<g class="so-label">
      <rect x="0.4" y="${ly - 2.4}" width="${labelW - 1.5}" height="4.4" rx="1" class="so-pill"/>
      <text x="${(labelW - 1.5) / 2 + .4}" y="${ly + .75}" text-anchor="middle" class="so-in">${t.z.w} × ${t.z.h} in</text>
      <text x="${(labelW - 1.5) / 2 + .4}" y="${ly + 4.6}" text-anchor="middle" class="so-cm">(${cm(t.z.w)} × ${cm(t.z.h)} cm)</text>
      <circle cx="${labelW}" cy="${ly - .2}" r=".45" class="so-dot"/>
      <polyline points="${labelW},${ly - .2} ${edgeX - 1.6},${ly - .2} ${edgeX},${edgeY}" class="so-line"/>
      <circle cx="${edgeX}" cy="${edgeY}" r=".4" class="so-dot"/>
    </g>`;
  });
  el.insertAdjacentHTML("beforeend", `<svg viewBox="0 0 ${W} ${H + 3}" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${boards}${labels}</svg>`);
}

document.addEventListener("click", e => {
  const open = e.target.closest("[data-size-guide-open]");
  if (open) {
    const d = document.getElementById(open.dataset.sizeGuideOpen);
    if (d) { const sg = $("[data-size-guide]", d); if (sg) initSizeGuide(sg); if (d.showModal) d.showModal(); else d.setAttribute("open", ""); }
    return;
  }
  if (e.target.closest("[data-size-guide-close]") || e.target.matches("dialog.sg-dialog")) {
    const d = e.target.closest("dialog"); if (d) { if (d.close) d.close(); else d.removeAttribute("open"); }
    return;
  }
  // mobile buy bar: adds only after a size was chosen, otherwise takes the shopper to the options
  const bb = e.target.closest("[data-buybar-btn]");
  if (bb) {
    const section = bb.closest("[data-product-section]"), form = $("form[id^='ProductForm-']", section);
    if (bb.dataset.picked === "true" && form) { form.requestSubmit(); return; }
    const opts = $("[data-variant-picker]", section) || form;
    if (opts) { opts.scrollIntoView({ behavior:"smooth", block:"center" }); opts.classList.add("flash"); setTimeout(() => opts.classList.remove("flash"), 1400); }
  }
});

document.addEventListener("input", e => {
  const inp = e.target.closest("[data-pers-input]"); if (!inp) return;
  const c = $("[data-pers-count]", inp.closest(".pers")); if (c) c.textContent = `${inp.value.length} / ${inp.maxLength}`;
});

// Ajax add-to-cart for product forms (properties included via form="" inputs)
document.addEventListener("submit", e => {
  const form = e.target;
  // getAttribute: a field named "id" (the variant) shadows form.id
  const fid = form.getAttribute("id") || "";
  if (fid.indexOf("ProductForm-") === 0) {
    e.preventDefault();
    const err = $("[data-form-error]", form); if (err) err.textContent = "";
    if (!form.checkValidity()) {
      const bad = $(":invalid", form);
      if (bad) { bad.scrollIntoView({ behavior:"smooth", block:"center" }); bad.focus({ preventScroll:true }); }
      form.reportValidity(); return;
    }
    Cart.add(null, $("[data-add-btn]", form), new FormData(form)).then(ok => { if (!ok && err) err.textContent = S.error; });
    return;
  }
  if (fid === "OfferForm") store.set("fskForm", "offer");
  else if (fid === "NewsletterForm") store.set("fskForm", "newsletter");
  else if (fid === "FooterNewsletterForm") store.set("fskForm", "footer");
});

document.addEventListener("change", e => {
  const t = e.target;
  if (t.matches("[data-finish]")) {
    const name = $("[data-finish-name]", t.closest(".pdp-pers")); if (name) name.textContent = t.value;
  }
  if (t.matches("[data-sort]")) {
    const url = new URL(location.href); url.searchParams.set("sort_by", t.value); url.searchParams.delete("page"); location.href = url;
  }
  if (t.matches("[data-autosubmit]")) {
    clearTimeout(t._fskT); t._fskT = setTimeout(() => t.form && t.form.submit(), 450);
  }
});

/* ====================== OFFER POPUP ====================== */
let offerShown = false;
function closeOffer(){ const o = $("[data-offer]"); if (o) o.classList.remove("open"); }
function showOffer(){
  const o = $("[data-offer]");
  if (!o || offerShown || store.get("offerSeen")) return;
  offerShown = true; store.set("offerSeen", "1");
  o.classList.add("open");
}

/* ====================== IMAGE HOVER (tilt, sheen, zoom) ====================== */
if (FSK.motion && matchMedia("(hover: hover)").matches && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
  const SEL = ".card .art, .cat .art, .mega-feat .art";
  let cur = null;
  const reset = el => { el.classList.remove("is-tilting"); el.style.setProperty("--rx","0deg"); el.style.setProperty("--ry","0deg"); };
  document.addEventListener("pointermove", e => {
    const el = e.target.closest ? e.target.closest(SEL) : null;
    if (cur && cur !== el) reset(cur);
    cur = el;
    if (!el) return;
    const r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
    el.style.setProperty("--ry", ((x - .5) * 10).toFixed(2) + "deg");
    el.style.setProperty("--rx", ((.5 - y) * 8).toFixed(2) + "deg");
    el.style.setProperty("--mx", (x * 100).toFixed(1) + "%");
    el.style.setProperty("--my", (y * 100).toFixed(1) + "%");
    el.classList.add("is-tilting");
  }, { passive:true });
  document.addEventListener("pointerleave", () => { if (cur) { reset(cur); cur = null; } });
}

/* ====================== HOME BACKDROP ======================
 * One fixed layer behind the home page. Its colour follows the section in the
 * middle of the screen and blends into the next one as it scrolls in, so the
 * page moves through the light tones without hard edges. The dark story band
 * keeps its own solid colour as a deliberate contrast step.
 */
const Backdrop = (() => {
  const bd = $("[data-backdrop]");
  if (!bd) return { refresh(){} };
  const root = document.documentElement;
  const VAR = { wall:"--wall", paper:"--paper", tint:"--tint" };
  const parse = c => {
    c = (c || "").trim();
    if (c[0] === "#") { if (c.length === 4) c = "#" + [...c.slice(1)].map(x => x + x).join(""); const n = parseInt(c.slice(1, 7), 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
    const m = c.match(/[\d.]+/g); return m ? m.slice(0, 3).map(Number) : [232, 236, 234];
  };
  const ease = t => t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  let stops = [], queued = false;
  function collect(){
    const cs = getComputedStyle(root);
    stops = $$("main [data-tone], main [data-tone-color]").map(el => ({ el, rgb:parse(el.dataset.toneColor || cs.getPropertyValue(VAR[el.dataset.tone] || "--wall")) }));
  }
  function update(){
    queued = false;
    if (!stops.length) return;
    const mid = innerHeight * .55, zone = innerHeight * .16;   // short blend: the change happens at the boundary
    let i = 0;
    stops.forEach((s, k) => { if (s.el.getBoundingClientRect().top <= mid) i = k; });
    let rgb = stops[i].rgb;
    const next = stops[i + 1];
    if (next) {
      const t = Math.min(1, Math.max(0, (mid + zone - next.el.getBoundingClientRect().top) / zone));
      if (t > 0) rgb = rgb.map((v, k) => Math.round(v + (next.rgb[k] - v) * ease(t)));
    }
    root.style.setProperty("--bd", `rgb(${rgb.join(",")})`);
    // faint skyline drifts sideways with the page and fades out on dark tones
    const max = Math.max(1, root.scrollHeight - innerHeight), p = Math.min(1, scrollY / max);
    const lum = (.2126 * rgb[0] + .7152 * rgb[1] + .0722 * rgb[2]) / 255;
    root.style.setProperty("--sk-x", ((.5 - p) * .16 * innerWidth).toFixed(1) + "px");
    root.style.setProperty("--sk-o", (.075 * Math.max(0, lum - .35) / .65).toFixed(3));
  }
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  addEventListener("scroll", queue, { passive:true });
  addEventListener("resize", () => { collect(); queue(); });
  collect(); update();
  return { refresh(){ collect(); queue(); } };
})();

/* ====================== 3D HERO PANEL FIT ======================
 * The buy panel must never scroll or be cut off. If the screen is still too
 * short after the compact CSS, shrink it just enough (--fit).
 */
function fitHeroPanels(){
  $$(".h3d").forEach(stage => {
    const panel = $(".h3d-panel", stage); if (!panel) return;
    panel.style.setProperty("--fit", 1);
    const stacked = getComputedStyle(panel).position !== "absolute";
    const need = panel.scrollHeight + (stacked ? 10 : 0);
    // side layout: keep 16px above and below; stacked: leave at least 34% of the stage for the 3D board
    const room = stacked ? stage.clientHeight * .70 : stage.clientHeight - (innerHeight < 500 ? 16 : 32);
    const fit = need > room ? Math.max(stacked ? .85 : (innerHeight < 500 ? .74 : .8), room / need) : 1;
    panel.style.setProperty("--fit", fit.toFixed(3));
  });
}
let fitTimer;
const queueFit = () => { clearTimeout(fitTimer); fitTimer = setTimeout(fitHeroPanels, 60); };
addEventListener("resize", queueFit);
if (document.fonts) document.fonts.ready.then(queueFit);
addEventListener("load", queueFit);

/* ====================== PER-SECTION SETUP (load + theme editor) ====================== */
let stickyIO;
function setup(root){
  fillShipDates(root);
  measureHeader();
  queueFit(); setTimeout(fitHeroPanels, 900);   // after the 3D script has added sizes and swatches
  $$("[data-size-guide]", root).forEach(el => { if (!el.closest("dialog")) initSizeGuide(el); });
  $$("[data-size-options]", root).forEach(el => drawSizeOptions(el));
  // Highlight the active color swatch based on the color_variants nav map
  $$(".swatches[data-color-nav]", root).forEach(swatches => {
    try {
      const map = JSON.parse(swatches.dataset.colorNav);
      const section = swatches.closest("[data-product-section]");
      if (!section) return;
      for (const [color, url] of Object.entries(map)) {
        if (location.pathname === url) {
          const btn = swatches.querySelector(`[data-value="${color}"]`);
          if (!btn) break;
          $$("[data-opt]", swatches).forEach(b => b.setAttribute("aria-pressed", b === btn));
          const label = section.querySelector(`[data-opt-label="${btn.dataset.opt}"]`);
          if (label) label.textContent = color;
          break;
        }
      }
    } catch(err) {}
  });
  $$("[data-buybar]", root).forEach(bar => {
    const add = $("[data-add-btn]", bar.closest("[data-product-section]"));
    if (!add || !window.IntersectionObserver) return;
    new IntersectionObserver(([en]) => { bar.hidden = en.isIntersecting || en.boundingClientRect.top > 0; }).observe(add);
  });

  // Sections slide up softly as they enter the screen (not in the theme editor, not with reduced motion)
  if (FSK.motion && window.IntersectionObserver && !(window.Shopify && window.Shopify.designMode) && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    // the section right after the hero (categories) is never delayed; others start just before they enter
    const els = $$(".sec-head, .cats, .rooms, main .grid, .reviews, .story-grid, .quote, .faq, .trust, .news, .promo-row", root)
      .filter(el => !el.classList.contains("reveal") && !el.closest("#categories"));
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }), { rootMargin:"0px 0px 12% 0px" });
    els.forEach(el => {
      el.classList.add("reveal");
      if (el.matches(".cats, main .grid, .reviews")) el.classList.add("reveal-delay");
      io.observe(el);
    });
  }

  // Mobile sticky CTA once the hero (or buy box) leaves the screen
  const cta = $("[data-sticky-cta]"), trigger = $("[data-sticky-trigger]");
  if (stickyIO) stickyIO.disconnect();
  if (cta && trigger) { stickyIO = new IntersectionObserver(([e]) => cta.classList.toggle("show", !e.isIntersecting)); stickyIO.observe(trigger); }

  // Product recommendations (needs its own request so `recommendations` is filled)
  $$("[data-recommendations]", root).forEach(async el => {
    if (el.dataset.loaded || el.children.length) return;
    el.dataset.loaded = "1";
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const fresh = $("[data-recommendations]", doc);
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; fillShipDates(el); }
    } catch (e) {}
  });

  // Finish name on the product page
  $$(".pdp-pers", root).forEach(p => { const c = $("[data-finish]:checked", p), n = $("[data-finish-name]", p); if (c && n) n.textContent = c.value; });

  // "Get a quote" links pass ?product=
  const product = new URLSearchParams(location.search).get("product");
  if (product) $$("[data-quote-product]", root).forEach(i => {
    i.value = product;
    const notes = $('textarea[name="contact[body]"]', i.form); if (notes && !notes.value) notes.value = product + ": ";
    // pick the matching panel type (e.g. "Staircase Panel" -> "Staircase panel")
    const sel = $('select[name="contact[Panel type]"]', i.form), key = product.toLowerCase();
    if (sel) [...sel.options].forEach(o => { const w = o.value.toLowerCase().split(" ")[0]; if (w.length > 3 && key.includes(w)) sel.value = o.value; });
  });
}

function boot(){
  setup(document);
  // #anchor links from other pages: re-align once the 3D hero and images have settled
  if (location.hash.length > 1) {
    const go = () => { const t = document.getElementById(decodeURIComponent(location.hash.slice(1))); if (t) t.scrollIntoView({ block:"start" }); };
    addEventListener("load", () => { go(); setTimeout(go, 600); }, { once:true });
  }
  addEventListener("resize", measureHeader);
  if (window.ResizeObserver) { const h = $(".fsk-header-section"); if (h) new ResizeObserver(measureHeader).observe(h); }

  // Customer forms share one result; show it where the form was sent from
  const sent = store.get("fskForm"); store.del("fskForm");
  if (sent === "offer") {
    $$('[data-form-result="newsletter"]').forEach(x => x.hidden = true);
    const r = $('[data-form-result="offer"]');
    if (r) { r.hidden = false; if (r.hasAttribute("data-ok")) { const f = r.closest("form"); $$("input, button", f).forEach(x => x.hidden = true); const tx = $("[data-offer-text]"); if (tx) tx.hidden = true; } offerShown = true; store.set("offerSeen", "1"); $("[data-offer]").classList.add("open"); }
  } else {
    $$('[data-form-result="offer"]').forEach(x => x.hidden = true);
    if (sent === "newsletter") { const n = $("#newsletter"); if (n) n.scrollIntoView({ block:"center" }); }
  }

  $$('[data-form-result="footer"]').forEach(x => { x.hidden = sent !== "footer"; });
  if (sent === "footer") {
    $$('[data-form-result="newsletter"],[data-form-result="offer"]').forEach(x => x.hidden = true);
    const ff = $("#FooterNewsletterForm"); if (ff) ff.scrollIntoView({ block:"center" });
  }

  // First-order offer: once per visit, after a delay or on exit intent (desktop)
  const offer = $("[data-offer]");
  if (offer && !(window.Shopify && window.Shopify.designMode)) {
    setTimeout(showOffer, (+offer.dataset.delay || 25) * 1000);
    document.addEventListener("mouseout", e => { if (!e.relatedTarget && e.clientY < 5) showOffer(); });
  }
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();

document.addEventListener("shopify:section:load", e => { setup(e.target); Backdrop.refresh(); });
document.addEventListener("shopify:section:unload", () => setTimeout(() => Backdrop.refresh()));
document.addEventListener("shopify:section:reorder", () => Backdrop.refresh());
document.addEventListener("shopify:section:select", e => { if (e.target.querySelector("[data-offer]")) $("[data-offer]").classList.add("open"); });
document.addEventListener("shopify:section:deselect", e => { if (e.target.querySelector("[data-offer]")) closeOffer(); });
})();
